<template>
    <div class="qf-pt-70px qf-pb-70px qf-color-white qf-image-bg">
        <div class="container">
            <div class="row justify-content-right align-items-right ">
                <div class="col text-right">
                    <span class="text-uppercase ">{{$ml.get('missing_account')}}</span>&nbsp;&nbsp;
                    <router-link to="/signup" class="btn btn-outline-light text-uppercase pr-4 pl-4">
                        {{$ml.get('sign_up')}}
                    </router-link>
                </div>
            </div>
            <div class="row justify-content-center align-items-center py-5">
                <div class="col text-center">
                    <router-link to="/">
                        <img src="../../assets/logo2.png" alt="ТМ">
                    </router-link>
                </div>
            </div>
            <div class="row justify-content-center align-items-center py-3">
                <div class="col text-center">
                    <h2>{{$ml.get('Account_Activation')}}</h2>
                </div>
            </div>
            <div class="row justify-content-center align-items-center py-3">
                <div class="col text-center" v-if="loading">
                    <p>{{$ml.get('Activating_Account')}}</p>
                    <p>
                        <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                    </p>
                </div>
                <div class="col text-center" v-else-if="success">
                    <p>{{$ml.get('Activating_Account_Success')}}</p>
                    <router-link to="/login" class="btn btn-outline-light text-uppercase mx-auto">{{$ml.get('log_in')}}</router-link>
                </div>
                <div class="col text-center" v-else>
                    <p>{{message}}</p>
                    <router-link to="/login" class="btn btn-outline-light text-uppercase mx-auto">{{$ml.get('log_in')}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ActivateAccount",
        data() {
            return {
                loading: true,
                success: false,
                message: ''
            }
        },
        beforeMount() {
            if (this.$route.query.access_token === undefined) {
                this.$router.push('/');
            } else {
                this.$store.dispatch('activate', {access_token: this.$route.query.access_token}).then(response => {
                    this.loading = false;
                    this.success = true;
                }).catch(error => {
                    if(error.status === 401){
                        this.message = error.data;
                    } else {

                    }
                    this.loading = false;
                });
            }
        },
    }
</script>

<style scoped>

</style>